import { useMemo } from 'react';

import { IdCardIcon } from '@radix-ui/react-icons';
import { Button, EmptyState, Link, Text } from '@raystack/apsara';

import { Show } from '@src/hoc';
import { openLinkInNewTab } from '@src/utils/commonUtils';

const BUSINESS_KYC_LINK =
  'https://app.cellbunq.com/portal/find-company/pixxel/4417deac-2116-4602-ae53-8211bec84034';

const CUSTOMER_KYC_LINK =
  'https://app.cellbunq.com/portal/find-company/pixxel/b0cbf0f2-032e-4096-90e0-bec1bb818b8d';

export const KycRequired = ({ isOrgOwner }: { isOrgOwner: boolean }) => {
  const mailLink = `mailto:${import.meta.env.VITE_SUPPORT_EMAIL}`;

  const subHeading = useMemo(() => {
    return isOrgOwner ? (
      <>
        For assistance, please email us at{' '}
        <Link
          external
          color='accent'
          href={mailLink}
          data-test-id='contact-support'
        >
          {import.meta.env.VITE_SUPPORT_EMAIL}
        </Link>
        . We're here to help!
      </>
    ) : (
      'Please contact your workspace owner to complete the KYC process for image orders.'
    );
  }, [isOrgOwner, mailLink]);

  return (
    <EmptyState
      icon={<IdCardIcon />}
      heading='KYC required for image orders'
      subHeading={subHeading}
      primaryAction={
        <Show when={isOrgOwner}>
          <Button
            variant='ghost'
            color='neutral'
            data-test-id='continue-for-businesses'
            onClick={e => {
              openLinkInNewTab(e, BUSINESS_KYC_LINK);
            }}
          >
            Continue for Businesses
          </Button>
        </Show>
      }
      secondaryAction={
        <Show when={isOrgOwner}>
          <Button
            variant='text'
            color='neutral'
            data-test-id='continue-for-individuals'
            onClick={e => {
              openLinkInNewTab(e, CUSTOMER_KYC_LINK);
            }}
          >
            <Text variant='accent' weight={500} size={1}>
              Continue for individuals
            </Text>
          </Button>
        </Show>
      }
    />
  );
};
